module.exports = __webpack_public_path__ + "img/5.2cff3773.jpg";